import { Product } from "@transfr-inc/dashboard-components/constants";

import {
  getCeOrganizationDailyStats,
  getCeOrganizationStats,
} from "./organization.utils";

export const ANNUAL_HOURS_WORKED = 2080;

export const getTrekDashboardStats = ({
  trekService,
  organizationService,
  orgCode,
  role,
  userId,
  filters,
  isMultiOrg,
}) => {
  const filtersWithProduct = { productId: Product.TRK, ...filters };

  const promises = [
    trekService.getInsights({
      orgCode,
      filters,
      options: {
        include_careers_explored: false,
      },
    }),
    getCeOrganizationStats({
      organizationService,
      userId,
      role,
      orgCode,
      filters: filtersWithProduct,
      getMultiOrg: isMultiOrg,
    }),
  ];

  return Promise.allSettled(promises).then((results) => {
    const [trekGenStats, { careersExplored: totalVRSimsExplored }] =
      results.map((r) => r.value);

    return { ...trekGenStats, totalVRSimsExplored };
  });
};

export const getTrekDashboardDailyStats = ({
  trekService,
  organizationService,
  orgCode,
  role,
  userId,
  filters,
  isMultiOrg,
}) => {
  const filtersWithProduct = { productId: Product.TRK, ...filters };

  const promises = [
    trekService.getInsights({
      orgCode,
      filters,
      daily: true,
      options: {
        include_careers_explored: false,
      },
    }),
    getCeOrganizationDailyStats({
      organizationService,
      userId,
      role,
      orgCode,
      filters: filtersWithProduct,
      getMultiOrg: isMultiOrg,
    }),
  ];

  return Promise.allSettled(promises).then((results) => {
    const [trekDailyStats, ceDailyStats] = results.map((r) => r.value);

    return mergeCeAndTrekDailyStats(ceDailyStats, trekDailyStats);
  });
};

const mergeCeAndTrekDailyStats = (ceDailyStats, trekDailyStats) => {
  const trekDailyStatsByDate = {};
  for (const stats of trekDailyStats) {
    trekDailyStatsByDate[stats.date] = stats;
  }

  for (const stats of ceDailyStats) {
    if (stats.date in trekDailyStatsByDate) {
      trekDailyStatsByDate[stats.date].totalVRSimsExplored =
        stats.careersExplored;
    } else {
      trekDailyStatsByDate[stats.date] = {
        date: stats.date,
        totalVRSimsExplored: stats.careersExplored,
      };
    }
  }

  return Object.values(trekDailyStatsByDate).sort((a, b) => a.date < b.date);
};
